<template>
  <div style="text-align:center;">
    <table border="1" style="border-bottom:0">
      <!-- 第一行(1表) -->
      <tr style="height:100px">
        <td width="30%" class="titleSpan companyTitle KaiTi">河南邦泰合力管理咨询有限公司</td>
        <td width="40%" class="titleSpan tableTitle">整 改 复 查 记 录 表</td>
        <td style="border:0" class="titleSpan">BTHL-GK-001</td>
      </tr>
    </table>
    <table border="1">
      <tr style="height:50px">
        <td width="30%" class="titleSpan">项目名称</td>
        <td colspan="3" class="contentSpan">{{'12312312312'}}</td>
      </tr>
      <tr style="height:50px">
        <td width="30%" class="titleSpan">复查人员</td>
        <td width="20%" class="contentSpan">{{'整 改 通 知 单'}}</td>
        <td width="15%" class="titleSpan">复查时间</td>
        <td class="contentSpan">{{'12312312312'}}</td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <tr style="height:100px">
        <td colspan="3" class="contentSpan">
          <div style="min-height:100px;box-sizing:border-box;padding:5px;text-align:left">
            <div>根据贵单位出具的整改意见和回复，我公司组织评价人员对贵公司已整改问题进行了现场复查，复查情况如下:</div>
            <div style="margin-top:10px" class="contentSpan">{{printData.company_name}}</div>
          </div>
        </td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <tr style="height:100px">
        <td colspan="4" style="text-align:left;">
          <div style="min-height:100px;box-sizing:border-box;padding:10px;" class="wirteTableRow">
            <div class="pic">
              <div>企业接收人签字:</div>
              <img src="../../assets/image/icon_MP4@2x.png" alt />
            </div>
            <div>年月日</div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      // 评价类别
      pjTypeList: [
        {
          id: '1',
          label: '预评价',
        },
        {
          id: '2',
          label: '验收评价',
        },
        {
          id: '3',
          label: '现状评价',
        },
        {
          id: '4',
          label: '专项评价',
        },
        {
          id: '5',
          label: '其它',
        },
      ],
    }
  },
  computed: {
    ...mapState('process/projectTable', ['printData']),
  },
  methods: {},
  mounted() {},
  async created() {},
}
</script>
<style lang="less" scoped>
@import url(./printDialog.scss);
</style>